import { TimePeriodOptions } from '../../../constants'
import { CookieConsentDomainScanStatuses } from '../domains/domainsSlice'

export const statusMessageMap = {
  [CookieConsentDomainScanStatuses.SUCCESS]: 'cookieConsent.domains.step2.scanCompleted',
  [CookieConsentDomainScanStatuses.FAILED]: 'cookieConsent.domains.step2.scanFailed',
  [CookieConsentDomainScanStatuses.IN_PROGRESS]: 'cookieConsent.domains.step2.scanInProgress'
}

export const consentEventTypeLabelMap = {
  'accept-all': 'cookieConsent.banners.acceptAll',
  'reject-all': 'cookieConsent.banners.rejectAll',
  'do-not-sell': 'cookieConsent.banners.chart.doNotSell',
  customize: 'cookieConsent.banners.customize'
}

export const LAST_MONTH = 'lastMonth'
export const LAST_QUARTER = 'lastQuarter'
export const LAST_YEAR = 'lastYear'

export const dateMaps = {
  [LAST_MONTH]: '30Days',
  [LAST_QUARTER]: '90Days',
  [TimePeriodOptions.SIX_MONTHS]: '180Days',
  [LAST_YEAR]: '1Year',
  [TimePeriodOptions.FROM_THE_START]: ''
}

export const getTimeDropdownOptions = (intl) => {
  return [
    {
      key: LAST_MONTH,
      value: LAST_MONTH,
      label: intl.formatMessage({ id: 'cookieConsent.overview.datefilter.lastMonth' })
    },
    {
      key: LAST_QUARTER,
      value: LAST_QUARTER,
      label: intl.formatMessage({ id: 'cookieConsent.overview.datefilter.lastQuarter' })
    },
    {
      key: LAST_YEAR,
      value: LAST_YEAR,
      label: intl.formatMessage({ id: 'cookieConsent.overview.datefilter.lastYear' })
    }
  ]
}
